var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPortalButtonDrums = function SvgPortalButtonDrums(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.186 4.17a.499.499 0 0 1 .936 0l.8 2.161c.05.137.158.244.294.295l2.161.8a.499.499 0 0 1 0 .935l-2.161.8a.499.499 0 0 0-.295.294l-.8 2.161a.499.499 0 0 1-.935 0l-.8-2.16a.499.499 0 0 0-.294-.295l-2.161-.8a.499.499 0 0 1 0-.935l2.161-.8a.499.499 0 0 0 .295-.295l.8-2.16Z",
    fill: "#24DF9C",
    fillOpacity: 0.75,
    shapeRendering: "crispEdges"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.292 8.323a.332.332 0 0 1 .624 0l.533 1.44a.332.332 0 0 0 .196.197l1.441.533c.29.107.29.517 0 .624l-1.44.533a.332.332 0 0 0-.197.197l-.533 1.44a.332.332 0 0 1-.624 0l-.533-1.44a.332.332 0 0 0-.196-.197l-1.441-.533a.333.333 0 0 1 0-.624l1.44-.533a.333.333 0 0 0 .197-.196l.533-1.44Z",
    fill: "#24DF9C",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.254 23.904a.25.25 0 0 1 .468 0l.4 1.08a.25.25 0 0 0 .147.147l1.08.4a.25.25 0 0 1 0 .468l-1.08.4a.25.25 0 0 0-.148.147l-.4 1.08a.25.25 0 0 1-.467 0l-.4-1.08a.25.25 0 0 0-.147-.147l-1.08-.4a.25.25 0 0 1 0-.468l1.08-.4a.25.25 0 0 0 .147-.147l.4-1.08Z",
    fill: "#24DF9C",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.236 9.278c.335-.905 1.615-.905 1.95 0l1.665 4.502c.105.284.33.509.614.614l4.502 1.666c.905.335.905 1.614 0 1.949l-4.502 1.665c-.284.106-.509.33-.614.614l-1.666 4.503c-.334.904-1.614.904-1.948 0l-1.666-4.503a1.04 1.04 0 0 0-.614-.614L8.455 18.01c-.905-.335-.905-1.614 0-1.95l4.502-1.665c.284-.105.508-.33.614-.614l1.665-4.502Z",
    fill: "#04FFA5"
  })));
};
export default SvgPortalButtonDrums;